import { createSlice } from '@reduxjs/toolkit';
export const initialState = { pwaStorageState: {} };
export const pwaStorageSlice = createSlice({
    name: 'pwaStorageSlice',
    initialState,
    reducers: {
        setPWAstorage(state, action) {
            state.pwaStorageState[action.payload.key] = action.payload.value;
        },
        resetPWAstorage(state, action) {
            state.pwaStorageState[action.payload.key] = null;
        },
    },
});
export const sliceName = pwaStorageSlice.name;
export const { setPWAstorage, resetPWAstorage } = pwaStorageSlice.actions;
// Selectors
export const getPWAstorage = (state) => state?.pwaStoragsReducer?.pwaStorageState;
const pwaStoragsReducer = pwaStorageSlice.reducer;
export default pwaStoragsReducer;
